import React, { useState } from 'react'
import ApiService from '../../../services/ApiService'
import OrdenoLogo from '../../../pages/Login/Login/img-login/ordeno-logo.png'

import {
  FullPageWrapper,
  Box,
  Logo,
  Title,
  Subtitle,
  OtpRow,
  OtpInput,
  ContinueButton,
  HelpRow,
  ResendLink,
  BackRow,
  BackIcon,
  BackText,
} from './style'

interface CodeInputProps {
  setPage: (page: string) => void
}

const CodeInput: React.FC<CodeInputProps> = ({ setPage }) => {
  // 6 dígitos
  const [otp, setOtp] = useState<string[]>(new Array(6).fill(''))

  // email salvo na tela de PassReset (se quiser salvar lá com localStorage.setItem('resetEmail', email))
  const email = localStorage.getItem('resetEmail') || ''

  const otpStr = otp.join('')
  const canContinue = otpStr.length === 6 && /^\d{6}$/.test(otpStr)

  const handleContinue = () => {
    if (!canContinue) return

    // guarda o código para a próxima tela (ResetPassword)
    localStorage.setItem('resetOTP', otpStr)
    setPage('ResetPassword')
  }

  const handleResend = async () => {
    try {
      if (!email) return
      await ApiService.auth.resetPassword(email)
      // aqui poderia ter um toast, mas visualmente não precisa
    } catch (err) {
      console.log(err)
    }
  }

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, idx: number) => {
    const el = e.target as HTMLInputElement
    if (e.key === 'Backspace') {
      const next = [...otp]
      next[idx] = ''
      setOtp(next)
      if (!el.value && el.previousElementSibling) {
        ;(el.previousElementSibling as HTMLInputElement).focus()
      }
    }
  }

  const onChange = (el: HTMLInputElement, idx: number) => {
    const val = el.value.replace(/\D/g, '').slice(0, 1)
    const next = [...otp]
    next[idx] = val
    setOtp(next)

    if (val && el.nextElementSibling) {
      ;(el.nextElementSibling as HTMLInputElement).focus()
    }
  }

  const onPasteFirst = (e: React.ClipboardEvent<HTMLInputElement>) => {
    const pasted = e.clipboardData
      .getData('text')
      .replace(/\D/g, '')
      .slice(0, 6)

    if (pasted) {
      const arr = pasted.split('')
      const next = otp.map((_, i) => arr[i] || '')
      setOtp(next)

      const nextIndex = Math.min(pasted.length, 5)
      const inputs =
        document.querySelectorAll<HTMLInputElement>('input[name="otp"]')
      inputs[nextIndex]?.focus()
      e.preventDefault()
    }
  }

  const maskedEmail = email
    ? email.replace(/^(.{4}).+(@.+)$/, '$1******$2')
    : 'seu email'

  return (
    <FullPageWrapper>
      <Box>
        <Logo src={OrdenoLogo} alt='ordeno' />

        <Title>Verifique seu email</Title>
        <Subtitle>
          Insira o código enviado para <strong>{maskedEmail}</strong>
        </Subtitle>

        <OtpRow>
          {otp.map((val, idx) => (
            <OtpInput
              key={idx}
              name='otp'
              type='text'
              inputMode='numeric'
              pattern='\d*'
              maxLength={1}
              value={val}
              autoFocus={idx === 0}
              onChange={(e) => onChange(e.target, idx)}
              onKeyDown={(e) => onKeyDown(e, idx)}
              onFocus={(e) => e.currentTarget.select()}
              onPaste={idx === 0 ? onPasteFirst : undefined}
            />
          ))}
        </OtpRow>

        <ContinueButton disabled={!canContinue} onClick={handleContinue}>
          Continuar
        </ContinueButton>

        <HelpRow>
          Não recebeu o código?
          <ResendLink type='button' onClick={handleResend}>
            Reenviar
          </ResendLink>
        </HelpRow>

        <BackRow onClick={() => setPage('Main')}>
          <BackIcon>←</BackIcon>
          <BackText>Voltar ao login</BackText>
        </BackRow>
      </Box>
    </FullPageWrapper>
  )
}

export default CodeInput
